export default __webpack_public_path__ + "static/media/AnimalMondey01_07.89e1918c.png";